import { render, staticRenderFns } from "./StoreHeader.vue?vue&type=template&id=07e12a6e&scoped=true"
import script from "./StoreHeader.vue?vue&type=script&lang=js"
export * from "./StoreHeader.vue?vue&type=script&lang=js"
import style0 from "./StoreHeader.vue?vue&type=style&index=0&id=07e12a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e12a6e",
  null
  
)

export default component.exports